import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

/**
 * Standard layout used by every static/legal page (About, Privacy, Contact).
 * Keeps navbar + footer consistent and updates <title> + meta description
 * for basic per-page SEO without SSR.
 */
export default function StaticPageLayout({
  eyebrow,
  title,
  description,
  metaTitle,
  metaDescription,
  children,
}) {
  useEffect(() => {
    document.title = metaTitle || `${title} — Giprompthub`;
    if (metaDescription) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", metaDescription);
    }
  }, [metaTitle, metaDescription, title]);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Navbar />
      <main className="max-w-3xl mx-auto px-5 md:px-10 pt-16 pb-20">
        {eyebrow && (
          <div className="font-mono-label text-[#00E5FF] mb-4">{eyebrow}</div>
        )}
        <h1 className="font-display text-4xl md:text-5xl tracking-tight leading-[1.05]">
          {title}
        </h1>
        {description && (
          <p className="mt-5 text-white/60 text-lg leading-relaxed">
            {description}
          </p>
        )}
        <div className="mt-12 prose-static">{children}</div>
      </main>
      <Footer />
    </div>
  );
}
